export const VALID_FIELD_STATE = {
  errorCode: '',
  isValid: true,
};

export const CARD_FIELDS_TO_DISPLAY = {
  cvv: true,
  dob: false,
  expiry: true,
};

export const ADDRESS_GROUP_REGEX = /^(billing|shipping|residential)Address$/;

export const SPINNER_TYPES = {
  almostDone: 'almostDone',
  empty: 'empty',
  takingYouBack: 'takingYouBack',
  thankYou: 'thankYou',
};
